import axios from "axios";

// Инициализация базового URL
let baseURL = window.myVariable || process.env.VUE_APP_URL_SERVER;

console.log(baseURL, process.env.VUE_APP_URL_SERVER);

// Создаем экземпляр axios
const apiInstance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Добавляем перехватчик для токена
apiInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Обработчик ошибок
apiInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default apiInstance;
